module.exports = __webpack_public_path__ + "img/icon-lock.cd08a35d.svg";